/**
 * Порти сховища. Домен звертається до даних лише через них — реалізація
 * живе в `@beresta/db` і різна на кожній платформі ([03](../../../../docs/03-architecture.md)).
 *
 * Усі методи асинхронні навмисно, а не «про всяк випадок»: у вебі база
 * лежить у воркері, тож кожен виклик — це обмін повідомленнями.
 */
/** Сховище не відповіло вчасно. Окремо від помилки самого запиту. */
export class StorageTimeoutError extends Error {
    operation;
    constructor(operation, ms) {
        super(`сховище не відповіло за ${ms} мс: ${operation}`);
        this.name = "StorageTimeoutError";
        this.operation = operation;
    }
}
/** Сховище померло: воркер завершився або впав. Відновлення — перезапуск. */
export class StorageDeadError extends Error {
    constructor(reason) {
        super(`сховище недоступне: ${reason}`);
        this.name = "StorageDeadError";
    }
}
//# sourceMappingURL=db.js.map